// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4bb39b01","313":"96ea1094","322":"697e73cb","422":"8017f441","558":"548a60f9","574":"8ed8d176","654":"b769c32a","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};